
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getTcsmEpiProps } from '../../global/ducks/epi-api';
import { AlertSites } from '../../pages/notification/notification-models';
import { SiteWideNotifications } from '../../pages/notification/site-wide-notification';

interface Props {
	siteSettingsId: string;
	currentCulture: string;
}

export function AlertContainer(props: Props) {
	const { siteSettingsId, currentCulture } = props;
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(getTcsmEpiProps(dispatch, siteSettingsId, { guid: null }, currentCulture, true));
	}, []);


	return (
		<SiteWideNotifications setSiteNotificationClosed={null} site={AlertSites.CPGORG} noReactLink useModal />

	);

}

